import { axios, organizationIdConfig } from 'configs'
import type {
  TRichMenuTemplatesResponse,
  TCreateRichMenuRequest,
  TRichMenuApplyAllResponse,
  TRichMenuClearDefaultAllResponse,
  TRichMenuCurrentResponse,
} from 'types'

export const listRichMenuTemplates = async () => {
  const response = await axios.get<TRichMenuTemplatesResponse>(
    '/line/rich-menu/templates',
  )

  return response.data
}

export const applyRichMenuToAllChannels = async (
  body: TCreateRichMenuRequest,
  organizationId?: number | null,
) => {
  const response = await axios.post<TRichMenuApplyAllResponse>(
    '/line/rich-menus/apply-all',
    body,
    organizationIdConfig(organizationId),
  )

  return response.data
}

export const getCurrentRichMenu = async () => {
  const response = await axios.get<TRichMenuCurrentResponse>(
    '/line/rich-menus/current',
  )

  return response.data
}

export const clearDefaultRichMenuFromAllChannels = async (
  organizationId?: number | null,
) => {
  const response = await axios.delete<TRichMenuClearDefaultAllResponse>(
    '/line/rich-menus/default-all',
    organizationIdConfig(organizationId),
  )

  return response.data
}
